import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { Box, Typography, useTheme } from "@mui/material"
import { DateRangePickerSeeker, IconSeeker } from "@ui-seeker/core"
import { differenceBetweenDates } from "@ui-seeker/utils"

import { DATE_PERIODS } from "../@constants"
import { dateRangeTranslator } from "../@utils"


function DateRangeLabel({currentPeriodLabel}) {
    return <Typography
        variant="caption"
        sx={{
            backgroundColor: "#eef1f3",
            py: .5,
            px: 1,
            textWrap: 'nowrap'
        }}
    >
        {dateRangeTranslator(currentPeriodLabel)}
    </Typography>
}

export default function DateRangeBlock({ currentPeriodLabel, maxDays, ...props }) {
    const { palette } = useTheme()
    const dateRange = useSignal([])
    const rangeDates = useSignal([])
    const currentPeriod = useSignal("")

    const dateRangeIcon = <Box component="span" sx={{ fontSize: 12, color: "text.disabled", pl: 1 }}>
        <IconSeeker icon="chevron-down" />
    </Box>

    return <Box sx={{ display: 'flex', gap: 2, alignItems: 'center'}}>
        <DateRangeLabel currentPeriodLabel={currentPeriodLabel} />
        <Box sx={{ height: 'auto'}} >
            <DateRangePickerSeeker
                placement="leftStart"
                value={dateRange.value}
                onChange={e => dateRange.value = e}
                caretAs={() => dateRangeIcon}
                ranges={rangeDates.value}
                shouldDisableDate = { (date, selectValue, selectedDone, target) => {
                    const currentDay = new Date()
                    if (date > currentDay) {
                        return true
                    }

                    if (target === 'CALENDAR' && selectValue.length === 1) {
                        const [start] = selectValue
                        if (start) {
                            return Math.abs(differenceBetweenDates(date, start)) + 1 > maxDays
                        }
                    }
                    return false
                }}
                onOk={() => currentPeriod.value = DATE_PERIODS.CUSTOM}
                containerProps={{ fullWidth: false }}
                css={{
                    "div[role='combobox']": {
                        borderColor: palette.background.default,
                        backgroundColor: `${palette.background.default} !important`,
                        paddingRight: "0 !important",
                        height: 37,

                        ".rs-picker-toggle-textbox": {
                            backgroundColor: palette.background.default
                        },

                        "&.rs-picker-toggle-active": {
                            borderColor: palette.background.default,
                            boxShadow: `0 0 0 0 ${palette.background.default}`
                        },

                        "&:hover": {
                            borderColor: `${palette.background.default} !important`
                        },

                        ".rs-picker-toggle-value": {
                            color: palette.text.disabled
                        }
                    }
                }}
                {...props}
            />
        </Box>
    </Box>
}